module.exports = __webpack_public_path__ + "static/media/temperature-hot.b4c53a33.svg";